import script from "./ContentCardSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentCardSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./ContentCardSkeleton.vue?vue&type=style&index=0&id=1e07080a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e07080a"]])

export default __exports__